<!-- 中期评审小组安排 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 29.74">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="11.61" cy="14.12" rx="0.97" ry="0.98" />
        <ellipse class="cls-2" cx="17.6" cy="21.14" rx="17.6" ry="8.6" />
        <ellipse class="cls-3" cx="17.6" cy="21.14" rx="13.61" ry="6.79" />
        <circle class="cls-4" cx="8.5" cy="14.46" r="1.09" />
        <path
          class="cls-4"
          d="M25.39,9.47a3.88,3.88,0,1,0-3.88-3.88,3.88,3.88,0,0,0,3.88,3.88Zm0-5.84a2.23,2.23,0,0,1,2.22,2.22,2.22,2.22,0,1,1-2.22-2.22ZM13.62,11.91a10.93,10.93,0,0,0-2.85.37.82.82,0,1,0,.44,1.59,9.65,9.65,0,0,1,2.41-.31,9.2,9.2,0,0,1,9,7.16.82.82,0,0,0,.81.64.44.44,0,0,0,.19,0,.83.83,0,0,0,.63-1,10.86,10.86,0,0,0-10.64-8.44ZM5.51,15.53A11.06,11.06,0,0,0,3,20.35a.82.82,0,0,0,.63,1,.58.58,0,0,0,.19,0,.82.82,0,0,0,.81-.64,9.34,9.34,0,0,1,2.12-4.09.83.83,0,0,0-1.24-1.1Zm26.81.7a7.31,7.31,0,0,0-7.18-5.71,7.42,7.42,0,0,0-3.61.94.82.82,0,1,0,.8,1.43,5.73,5.73,0,0,1,8.38,3.7.83.83,0,0,0,.81.64.44.44,0,0,0,.19,0,.79.79,0,0,0,.61-1ZM19,5.38a5.38,5.38,0,1,0-5.37,5.39A5.4,5.4,0,0,0,19,5.38Zm-9.1.68a3.72,3.72,0,1,1,3.71,3.73,4,4,0,0,1-.86-.11A3.72,3.72,0,0,1,9.91,6.06Z"
        />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 29.74">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="11.61" cy="14.12" rx="0.97" ry="0.98" />
        <ellipse class="cls-2" cx="17.6" cy="21.14" rx="17.6" ry="8.6" />
        <ellipse class="cls-3" cx="17.6" cy="21.14" rx="13.61" ry="6.79" />
        <circle class="cls-1" cx="8.5" cy="14.46" r="1.09" />
        <path
          class="cls-1"
          d="M25.39,9.47a3.88,3.88,0,1,0-3.88-3.88,3.88,3.88,0,0,0,3.88,3.88Zm0-5.84a2.23,2.23,0,0,1,2.22,2.22,2.22,2.22,0,1,1-2.22-2.22ZM13.62,11.91a10.93,10.93,0,0,0-2.85.37.82.82,0,1,0,.44,1.59,9.65,9.65,0,0,1,2.41-.31,9.2,9.2,0,0,1,9,7.16.82.82,0,0,0,.81.64.44.44,0,0,0,.19,0,.83.83,0,0,0,.63-1,10.86,10.86,0,0,0-10.64-8.44ZM5.51,15.53A11.06,11.06,0,0,0,3,20.35a.82.82,0,0,0,.63,1,.58.58,0,0,0,.19,0,.82.82,0,0,0,.81-.64,9.34,9.34,0,0,1,2.12-4.09.83.83,0,0,0-1.24-1.1Zm26.81.7a7.31,7.31,0,0,0-7.18-5.71,7.42,7.42,0,0,0-3.61.94.82.82,0,1,0,.8,1.43,5.73,5.73,0,0,1,8.38,3.7.83.83,0,0,0,.81.64.44.44,0,0,0,.19,0,.79.79,0,0,0,.61-1ZM19,5.38a5.38,5.38,0,1,0-5.37,5.39A5.4,5.4,0,0,0,19,5.38Zm-9.1.68a3.72,3.72,0,1,1,3.71,3.73,4,4,0,0,1-.86-.11A3.72,3.72,0,0,1,9.91,6.06Z"
        />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.2 30.49">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="21.89" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="21.89" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M25.19,9.08a3.72,3.72,0,1,0-3.72-3.72,3.72,3.72,0,0,0,3.72,3.72Zm0-5.6A2.13,2.13,0,0,1,26.62,4a2.1,2.1,0,0,1,.7,1.57,2.14,2.14,0,1,1-2.13-2.13ZM13.9,11.42a10.51,10.51,0,0,0-2.74.36.79.79,0,0,0,.42,1.53A9,9,0,0,1,13.9,13a8.82,8.82,0,0,1,8.64,6.87.8.8,0,0,0,.77.62.44.44,0,0,0,.19,0,.8.8,0,0,0,.6-.95,10.43,10.43,0,0,0-10.2-8.1ZM6.11,14.9a10.63,10.63,0,0,0-2.4,4.62.79.79,0,0,0,.6.95,1,1,0,0,0,.19,0,.81.81,0,0,0,.77-.62A8.94,8.94,0,0,1,7.3,16,.8.8,0,0,0,6.11,14.9Zm25.73.67a7,7,0,0,0-6.9-5.48,7.19,7.19,0,0,0-3.46.9.79.79,0,0,0,.77,1.38,5.51,5.51,0,0,1,2.69-.7,5.44,5.44,0,0,1,5.35,4.25.8.8,0,0,0,.78.61.42.42,0,0,0,.18,0,.77.77,0,0,0,.59-.93ZM19.06,5.17a5.16,5.16,0,1,0-5.15,5.16,5.17,5.17,0,0,0,5.15-5.16Zm-8.73.64A3.57,3.57,0,1,1,13.9,9.39a3.77,3.77,0,0,1-.83-.1,3.57,3.57,0,0,1-2.74-3.48Z"
        />
        <ellipse class="cls-3" cx="8.96" cy="13.91" rx="0.93" ry="0.94" />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #2eac90;
    }
    .cls-2 {
      fill: #f0f7f7;
    }
    .cls-3 {
      fill: #d7e2e2;
    }
    .cls-4 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #ed9c24;
    }
    .cls-2 {
      fill: #f4e4d4;
    }
    .cls-3 {
      fill: #efd0a3;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3 {
      fill: #2eac90;
    }
  }
</style>
